module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-731-min.708bbbb7.jpg";